import { connect } from 'react-redux'
import {
  getNodesByIds,
  getClash,
} from '../../core/selectors'
import CheckCircle from '../components/checkCircle'

const mapStateToProps = (state, ownProps) => ({
  conflicts: (Array.isArray(ownProps.conflicts) && getNodesByIds({
    state,
    ids: ownProps.conflicts,
  })),
  requires: (Array.isArray(ownProps.requires) && getNodesByIds({
    state,
    ids: ownProps.requires,
  })),
  config: getClash(state),
})

export default connect(
  mapStateToProps,
  null,
)(CheckCircle)



// WEBPACK FOOTER //
// ./src/modules/core/containers/checkCircle.js